import React, { useState } from 'react';
import { Box, Typography } from '@material-ui/core';
import info from '../redesign-5.2/images/infoBlue.png';
import infoDark from '../redesign-5.2/images/noticeDark.png';
import noticeStyles from './noticeStyles';
import { useApolloClient } from '@apollo/client';

const AlertOfForgotPassword = ({ email, flag = '' }) => {
    const classes = noticeStyles();
    const [isCanceled, setIsCanceled] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const graphql = useApolloClient();

    const closeAction = () => {
        setIsCanceled(true);
    };

    const handleRegister = () => {
        window.location.href = '/register';
    };
    return (
        <>
            {flag == 'mfa' ? (
                <Box
                    className={classes.alertContainerMFA}
                    style={{ marginTop: 0, marginBottom: 0 }}
                >
                    <Box
                        className={classes.noticeElements}
                        style={{ marginTop: 0, marginBottom: 0 }}
                    >
                        <Box component='img' src={infoDark} alt='' className={classes.info} />

                        <Box className={classes.alertTextMFA}>
                            We'll use this as your account contact number going forward.
                        </Box>
                    </Box>
                </Box>
            ) : (
                <Box>
                    {!isCanceled && (
                        <Box className={classes.alertContainer}>
                            <Box className={classes.noticeElements}>
                                <Box component='img' src={info} alt='' className={classes.info} />

                                <Box className={classes.alertText}>
                                    If you haven’t received an email, please check your spam folder.
                                    If it’s not there, you may not be registered.
                                    <Typography
                                        component='span'
                                        className={classes.textBold}
                                        onClick={handleRegister}
                                    >
                                        Register for your eir account.
                                    </Typography>{' '}
                                </Box>
                            </Box>
                        </Box>
                    )}
                </Box>
            )}
        </>
    );
};

export default AlertOfForgotPassword;
